interface ItemClass {
	name: string;
	subClasses: { [key: number]: { name: string } };
}

export default {
	0: {
		name: "Consumable",
		subClasses: {
			8: {
				name: "Other"
			},
		}
	},
	2: {
		name: "Weapon",
		subClasses: {
			0: {
				name: "One-Handed Axe"
			},
			1: {
				name: "Two-Handed Axe"
			},
			2: {
				name: "Bow"
			},
			3: {
				name: "Gun"
			},
			4: {
				name: "One-Handed Mace"
			},
			5: {
				name: "Two-Handed Mace"
			},
			6: {
				name: "Polearm"
			},
			7: {
				name: "One-Handed Sword"
			},
			8: {
				name: "Two-Handed Sword"
			},
			9: {
				name: "Warglaive"
			},
			10: {
				name: "Staff"
			},
			11: {
				name: "Bear Claw"
			},
			12: {
				name: "Cat Claw"
			},
			13: {
				name: "Fist Weapon"
			},
			14: {
				name: "Miscellaneous"
			},
			15: {
				name: "Dagger"
			},
			16: {
				name: "Thrown"
			},
			18: {
				name: "Crossbow"
			},
			19: {
				name: "Wand"
			},
			20: {
				name: "Fishing Pole"
			},
		}
	},
	4: {
		name: "Armor",
		subClasses: {
			0: {
				name: "Miscellaneous"
			},
			1: {
				name: "Cloth"
			},
			2: {
				name: "Leather"
			},
			3: {
				name: "Mail"
			},
			4: {
				name: "Plate"
			},
			5: {
				name: "Cosmetic"
			},
			6: {
				name: "Shield"
			},
			11: {
				name: "Relic"
			},
		}
	},
	15: {
		name: "Miscellaneous",
		subClasses: {
			2: {
				name: "Companion Pet"
			},
			5: {
				name: "Mount"
			},
		}
	}
} as { [key: number]: ItemClass };

